import { type MenuOption } from '@saviynt/design-system';

export interface MitigateControlListSortFieldState {
  label: string;
  value: string;
  isChecked?: boolean;
  options?: string[];
}

export const MC_LIST_SORT_ACTIONS: Record<string, MenuOption> = {
  ATOZ: {
    label: 'A to Z',
    value: 'ATOZ',
  },
  ZTOA: {
    label: 'Z to A',
    value: 'ZTOA',
  },
  MOSTCRITICAL: {
    label: 'Most Critical',
    value: 'MOSTCRITICAL',
  },
  LEASTCRITICAL: {
    label: 'Least Critical',
    value: 'LEASTCRITICAL',
  },
} as const;

export const SORT_ACTION_MAPPING: Record<string, string> = {
  [MC_LIST_SORT_ACTIONS.ATOZ.value]: 'ASC',
  [MC_LIST_SORT_ACTIONS.ZTOA.value]: 'DESC',
  [MC_LIST_SORT_ACTIONS.MOSTCRITICAL.value]: 'DESC',
  [MC_LIST_SORT_ACTIONS.LEASTCRITICAL.value]: 'ASC',
  DESC: 'DESC',
  ASC: 'ASC',
} as const;

export const MC_LIST_SORT_FIELDS: Record<
  string,
  MitigateControlListSortFieldState
> = {
  MITIGATINGCONTROL: {
    label: 'Mitigating Control',
    value: 'mitigatingControl',
    options: [MC_LIST_SORT_ACTIONS.ATOZ.value, MC_LIST_SORT_ACTIONS.ZTOA.value],
  },
  PRIORITY: {
    label: 'Priority',
    value: 'priority',
    options: [
      MC_LIST_SORT_ACTIONS.MOSTCRITICAL.value,
      MC_LIST_SORT_ACTIONS.LEASTCRITICAL.value,
    ],
  },
};
